// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","paper":"_3LACdiwcsIpx","controls":"_1_71WLPbMKah","button":"_3ucCzxU_IrQB","cancel":"_2y0maC73C5Ed"};